/**
 * Use GenericChart.tsx to edit this and other similar component
 */
import * as React from 'react';
import { Radar as CurrentChart } from 'react-chartjs-2';

import { GenericChartRender } from './GenericChart';
import { SharedChartRenderProps } from './Shared';
import { observer } from 'mobx-react';

@observer
export class ChartRender extends React.Component<SharedChartRenderProps> {
    render() {
        return (
            <GenericChartRender 
                {...this.props} 
                ChartTypeGenerator={(props) => <CurrentChart {...props} />}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/Chart/renders/Radar.tsx